import { ThemeDefinition } from '../../types/epubs';

const commonRules = {
  body: {
    'line-height': '170%',
  },
};
export const epubThemes: { [index: string]: ThemeDefinition } = {
  night: {
    ...commonRules,
    body: {
      'background-color': '#12263f',
      color: '#f9fbfd',
    },
  },
  day: {
    ...commonRules,
    body: {
      'background-color': '#ffffff',
      color: '#000000',
    },
  },
  sepia: {
    ...commonRules,
    body: {
      'background-color': '#f8f1e3',
      color: '#000000',
    },
  },
};
